import { ASThemeDefault, CalendarRangeIcon, EmailIcon, HouseIcon, TravelIcon } from '@eleventheye/asui';
import { getFormattedGameDate } from '@shared/helpers';
import { IGameStats, IMatchup } from '@shared/types';
import { getGameStatus } from 'helpers/StringHelpers';
import React from 'react';
import { IGameInfo } from 'types';

import styles from './PopupContent.module.scss';

type PopupContentProps = {
  className?: string;
  gameStats?: IGameStats | IMatchup;
  gameInfo?: IGameInfo;
  isByeWeek?: boolean;
  disabled?: boolean;
};

const PopupContent: React.FC<PopupContentProps> = ({
  className = '',
  gameStats,
  gameInfo,
  isByeWeek = false,
  disabled = false,
}) => {
  const baseCls = `${styles.PopupContainer} ${className}`;
  const winCls = `${styles.PopupGameScore} ${styles.Win}`;
  const homeWinCls = gameStats?.homeResult === 'W' ? winCls : '';
  const awayWinCls = gameStats?.awayResult === 'W' ? winCls : '';
  const awayPts = gameStats?.awayPts || '-';
  const homePts = gameStats?.homePts || '-';
  const status = getGameStatus(gameStats);
  const date = getFormattedGameDate(gameStats?.gameDate);
  const homeStkWidth = gameStats?.homeResult === 'W' ? 1.5 : 0.5;
  const awayStkWidth = gameStats?.awayResult === 'W' ? 0.1 : 1;

  if (disabled) return null;

  return (
    <div className={baseCls}>
      {isByeWeek ? (
        <span className={styles.PopupGameByeWeek}>BYE WEEK</span>
      ) : (
        <>
          <div className={styles.PopupGameBracket}>
            <div className={`${styles.PopupGameTeams} ${awayWinCls}`}>
              <div className={styles.PopupGameDateIcon}>
                <CalendarRangeIcon
                  color={ASThemeDefault.colors.mainGray22}
                  fillColor={ASThemeDefault.colors.mainGray22}
                  iconSize={16}
                />
              </div>
              <span className={styles.PopupGameDate}>{date}</span>
            </div>
            <div className={`${styles.PopupGameTeams} ${awayWinCls}`}>
              <div className={styles.PopupGameAwayIcon}>
                <TravelIcon
                  color={ASThemeDefault.colors.mainYellow}
                  fillColor={ASThemeDefault.colors.mainGray22}
                  iconSize={16}
                  strokeWidth={awayStkWidth}
                />
              </div>
              <span className={styles.PopupGameAwayTeam}>{gameInfo?.awayAbrv}</span>
              <span className={styles.PopupGameAwayScore}>{awayPts}</span>
            </div>
            <div className={`${styles.PopupGameTeams} ${homeWinCls}`}>
              <div className={styles.PopupGameHomeIcon}>
                <HouseIcon
                  color={ASThemeDefault.colors.mainGray22}
                  fillColor={ASThemeDefault.colors.mainGray22}
                  iconSize={16}
                  strokeWidth={homeStkWidth}
                />
              </div>
              <span className={styles.PopupGameHomeTeam}>{gameInfo?.homeAbrv}</span>
              <span className={styles.PopupGameHomeScore}>{homePts}</span>
            </div>
            {/* Two circles with @ symbol and game status letters F - finished, S - scheduled, P - in progress */}
            <div className={styles.PopupGameAt}>
              <EmailIcon
                className={styles.IconLayout}
                iconSize={14}
                strokeWidth={0.4}
                fillColor={ASThemeDefault.colors.mainYellow}
                color={ASThemeDefault.colors.mainYellow}
              />
            </div>
            <span className={styles.PopupGameStatus}>{status}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default PopupContent;
